import { ref } from "vue";
import { useAuthenticatedFetch } from "../auth/useAuthenticatedFetch";

import {
  Presence,
  PresenceRequest,
  PresenceSearchParams,
  DailyActivitySearchParams,
  ActivityRecord,
} from "@/interfaces/presence";
import { presences, clubUUID, paginationLinks } from "@/shared/state";
import { useGlobal } from "@/composables/global/useGlobal";

const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;

import Swal from "sweetalert2";
import i18n from "@/i18n/index";
const Toast = Swal.mixin({
  toast: true,
  position: "top-right",
  showConfirmButton: false,
  timer: 12000,
  timerProgressBar: true,
});

export function usePresence() {
  const errorPresence = ref<boolean | false>(false);
  const isRequestPresence = ref<boolean | false>(false);
  const activityData = ref<ActivityRecord[]>([]);
  const { playSound } = useGlobal();
  const fetchPresences = async (body: PresenceSearchParams) => {
    try {
      isRequestPresence.value = true;
      errorPresence.value = false;
      presences.data = [];
      paginationLinks.value = 0;
      const response = await authenticatedFetch(
        `${API_URL}presences/search`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response) {
        console.log("test 1");
        if (body?.type === "paginate") {
          console.log("test 2");
          presences.data = response?.data?.data || [];
          paginationLinks.value = response?.data;
          delete paginationLinks.value.data;
        } else {
          // fiche_presence.data = response?.data || {}
        }
        isRequestPresence.value = false;
      }
    } catch (err: any) {
      errorPresence.value = true;
      isRequestPresence.value = false;
    }
  };
  const fetchDailyActivities = async (body: DailyActivitySearchParams) => {
    try {
      isRequestPresence.value = true;
      errorPresence.value = false;
      activityData.value = [];
      paginationLinks.value = 0;
      const response = await authenticatedFetch(
        `${API_URL}presences/daily`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response) {
        console.log("test 1");
        activityData.value = response?.data;
        console.log(activityData.value);
        isRequestPresence.value = false;
      }
    } catch (err: any) {
      errorPresence.value = true;
      isRequestPresence.value = false;
    }
  };
  const addPresence = async (body: PresenceRequest) => {
    try {
      isRequestPresence.value = true;
      errorPresence.value = false;
      const response = await authenticatedFetch(
        `${API_URL}presences/store/${clubUUID.value}`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        true,
      );
      if (response) {
        const PresenceAdded: Presence = response?.data;
        const index = presences?.data?.findIndex(
          (presence) => presence?.id === PresenceAdded?.id,
        );
        if (index !== -1) {
          presences.data[index] = PresenceAdded;
        } else presences?.data?.unshift(PresenceAdded);

        if (!PresenceAdded?.checkOut) {
          Toast.fire({
            title: "Séance commencée",
            icon: "success",
          });
        } else {
          Toast.fire({
            title: "Séance terminée",
            icon: "success",
          });
        }
        playSound("success.mp3");
      }
      isRequestPresence.value = false;
    } catch (err: any) {
      errorPresence.value = true;
      isRequestPresence.value = false;
      playSound("error.mp3");
    }
  };

  const editPresence = async (body: PresenceRequest) => {
    try {
      isRequestPresence.value = true;
      errorPresence.value = false;
      const response = await authenticatedFetch(
        `${API_URL}presences/edit/${body?.id}/${clubUUID.value}`,
        {
          method: "PUT",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response) {
        const PresenceEdited: Presence = response?.data;
        const index = presences?.data?.findIndex(
          (presence) => presence?.id === PresenceEdited?.id,
        );
        if (index !== -1) {
          presences.data[index] = PresenceEdited;
        }
      }
      isRequestPresence.value = false;
    } catch (err: any) {
      errorPresence.value = true;
      isRequestPresence.value = false;
    }
  };

  const deletePresence = async (id: number) => {
    try {
      isRequestPresence.value = true;
      errorPresence.value = false;
      const response = await authenticatedFetch(
        `${API_URL}presences/delete/${id}/${clubUUID.value}`,
        {
          method: "DELETE",
        },
        true,
        "",
        true,
      );
      const index = presences?.data?.findIndex(
        (presence) => presence?.id === id,
      );
      if (index !== -1) {
        presences.data.splice(index, 1);
      }
      isRequestPresence.value = false;
    } catch (err: any) {
      errorPresence.value = true;
      isRequestPresence.value = false;
    }
  };

  return {
    addPresence,
    editPresence,
    deletePresence,
    isRequestPresence,
    errorPresence,
    fetchPresences,
    fetchDailyActivities,
    activityData,
  };
}
